module.exports = __webpack_public_path__ + "static/product-lims-5ab9de2cc332bcef906a1755b4efc5b5.png";